import { render, staticRenderFns } from "./PackgingTab.vue?vue&type=template&id=66e60e9c&scoped=true&"
import script from "./PackgingTab.vue?vue&type=script&lang=js&"
export * from "./PackgingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e60e9c",
  null
  
)

export default component.exports